var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "24px",
    viewBox: "0 -960 960 960",
    width: "24px",
    fill: "#8A99BB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440-499.31Zm0 325.23-33.62-31q-97.76-90.77-161.03-153.54-63.27-62.76-100.2-110.69-36.92-47.92-51.03-85.59Q80-592.57 80-632.69q0-74.62 50.5-126.35 50.5-51.73 124.88-51.73 54.7 0 101.66 29.19Q404-752.38 440-696q38.92-57.85 84.68-86.31 45.75-28.46 99.99-28.46 68.21 0 117.16 47.31 48.94 47.31 55.55 116.08h-29q-5.15-55.77-44.57-94.2Q684.38-780 624.62-780q-49.47 0-91.93 29.08-42.46 29.07-76.38 90.69h-33.62q-33.69-61.39-75.9-90.58Q304.57-780 255.38-780q-62.15 0-103.38 42.19t-41.23 105.12q0 36.69 14.73 72.54 14.73 35.84 51.58 82.53 36.85 46.68 101.04 109.23Q342.31-305.85 440-215.38q32.77-30.54 59.73-54.77 26.96-24.23 53.42-49l3.56 3.39q3.55 3.4 7.44 7.49 3.89 4.09 7.45 7.49l3.55 3.4q-26.23 24-52.92 47.84-26.69 23.85-59.69 54.62L440-174.08ZM713.85-300v-124.62H589.23v-30.76h124.62V-580h30.77v124.62h124.61v30.76H744.62V-300h-30.77Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ba44f224.svg";
export { ForwardRef as ReactComponent };